import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import React from "react";
import moment from "moment";
import { Card } from "Components/Card";
import classNames from "classnames";
import { DayActivityViewModel } from "Services/API/API";
import { AvatarCircle } from "Components/AvatarCircle";
import { GuestAvatarList } from "./GuestAvatarList";
import { UncontrolledTooltip } from "reactstrap";

interface CalendarDayProps {
    activity: DayActivityViewModel,
    date: moment.Moment,
    onClick: (day: DayActivityViewModel) => void,
    index: number;
}

export const CalendarDay: React.FC<CalendarDayProps> = ({activity, date, index, onClick}) => {
    const isMobile = useMediaBreakpointDown("xs");
    const isIpad = useMediaBreakpointDown("sm");

    return <Card className={classNames("text-truncate", { "day-active": date.isSame(activity.date) })} onClick={() => onClick(activity)}>
    <div className="day-wrapper text-truncate">
       <div className="day-info text-truncate">
          <div className="day-of-month">{moment(activity.date).format("D")}</div>
          <div className="day-of-week text-truncate">{moment(activity.date).format(isMobile ? "ddd":"dddd")}</div>
       </div>
       {
          !isIpad && activity.member && <div className="avatar-wrapper">
             <AvatarCircle colorIndex={0} {...activity.member} />
          </div>
       }
    </div>
    { 
       !isMobile && <div className={classNames("colleagues-list", { "colleagues-list--default": activity.coworkers.length == 0 })}>
          {
             activity.coworkers.length > 0
                ? <GuestAvatarList id={`colleagues-day-${index}`} organizer={undefined} guests={activity.coworkers} capacity={0} displayCount={isIpad ? 2 : 4} />
                : <div className="empty-state text-truncate">No coworker activity</div>
          }
       </div>
    }
    { !isMobile && activity.coworkers.length > 0 && <UncontrolledTooltip autohide={false} target={`colleagues-day-${index}`} className="colleagues-list-tooltip" placement="top" fade={false}>
       View your coworkers activity below.
    </UncontrolledTooltip> }
 </Card>
}